// import { isObject } from "core-web/utils/object";

/**
 * Takes a heading from the cms and renames/restructures the data so that it is easier to work with in the front-end.
 * All front-end components should expect the heading to first pass through this function.
 * @param {object} heading - heading data straight from the cms.
 * @param {object} - Transformed heading data.
 */

const FONT_SIZES = {
    16: "Myriad Pro/16-100-semibold-semiextended",
    18: "Myriad Pro/18-100-semibold-semiextended",
    20: "Myriad Pro/20-100-semibold",
    24: "Myriad Pro/24-100-semibold",
    32: "Myriad Pro/32-100-semibold",
    40: "Myriad Pro/40-100-semibold",
    48: "Myriad Pro/48-100-semibold",
    56: "Myriad Pro/56-100-semibold",
    64: "Myriad Pro/64-100-semibold",
};

export default (heading = {}, layout = undefined, numberOfColumns = undefined) => {
    const headingObject = {};

    // Just return empty object if we don't have any data
    if (!heading) {
        return headingObject;
    }

    // Just return text if heading is of type string
    if (typeof heading === "string") {
        headingObject["text"] = heading;
        return headingObject;
    }

    const isFlexible = layout === "flexible";
    const text = heading.text || heading.heading?.text || undefined;
    const type = heading.type || heading.heading?.type || undefined;
    const color = heading.text_color || heading.heading?.text_color || undefined;
    const fontSizes = heading.text_size || heading.heading?.text_size;

    headingObject["text"] = text;
    headingObject["type"] = type === "default" ? (isFlexible ? "h3" : "h2") : type;
    headingObject["color"] = color === "default" ? undefined : color;

    // if (typeof text === "string") {
    //     headingObject["text"] = text;
    // }

    // if (heading.is_manual_type && type) {
    //     headingObject["type"] = type;
    // }

    //based on number of columns, the default heading size variates
    const flexibleDefaultOption = {
        1: [FONT_SIZES[40], null, null, null, FONT_SIZES[64]],
        2: [FONT_SIZES[32], null, null, null, FONT_SIZES[40]],
        3: [FONT_SIZES[32], null, null, null, FONT_SIZES[40]],
    };

    headingObject["textStyle"] =
        fontSizes === "default"
            ? isFlexible
                ? flexibleDefaultOption[numberOfColumns]
                : [FONT_SIZES[24], null, null, null, FONT_SIZES[32]]
            : FONT_SIZES[fontSizes];

    // if (heading.is_manual_font_size && isObject(fontSizes)) {
    //     const {
    //         mobile_font_size: mobile,
    //         tablet_font_size: tablet,
    //         desktop_font_size: desktop,
    //         large_desktop_font_size: largeDesktop,
    //     } = fontSizes;

    //     // headingObject["textStyle"] = [
    //     //     FONT_SIZES[mobile],
    //     //     null,
    //     //     null,
    //     //     FONT_SIZES[tablet],
    //     //     FONT_SIZES[desktop],
    //     //     null,
    //     //     FONT_SIZES[largeDesktop],
    //     // ];
    // }

    // Return the transformed data.
    return headingObject;
};
